// Libs
// import { createSelector } from 'reselect'

// Exports
export default (state) => state.mapModule.spatial[state.mapModule.editingSpatial]
